import React, { useState, useMemo } from 'react';
import { useLoaderData } from '@tanstack/react-router';

import { APIupdateAsset } from '../../../../api/Assets';

import DashboardAdminAssetsUpload from './Upload';

import type { UppyFile } from '@uppy/core';
import type { Asset } from '../../../../types/asset';
import type { AssetMetadata } from '../../../../types/asset-metadata';

const DashboardAdminAssetsAdd: React.FC = () => {
  const { assetGroups } = useLoaderData({ strict: false });
  const [files, setFiles] = useState<UppyFile<Record<string, unknown>, Record<string, unknown>>[]>([]);
  const [uploading, setUploading] = useState(false);

  const assets = useMemo(() => {
    return files
      .map((file: (UppyFile<Record<string, unknown>, Record<string, unknown>> | Asset)) => {
      if (file.progress) {
        return {
          id: (file as UppyFile<Record<string, unknown>, Record<string, unknown>>).meta?.uuid || file.id,
          name: (file as UppyFile<Record<string, unknown>, Record<string, unknown>>).name,
          title: 'title' in file ? file.title : '',
          metadata: {
            hidden: 'hidden' in file ? file.hidden : false,
          },
          groups: 'groups' in file ? file.groups : [],
          type: file.type,
          path: (file as UppyFile<Record<string, unknown>, Record<string, unknown>>).uploadURL ?? (file as Asset).path ?? '',
          size: file.size,
          thumbnail: (file as UppyFile<Record<string, unknown>, Record<string, unknown>>).preview as string ?? (file as Asset).thumbnail ?? '',
          progress: file.progress,
          error: file.error,
          status: (file as UppyFile<Record<string, unknown>, Record<string, unknown>>).response?.status ?? (file as Asset).status,
          local: true,
          uppyFileId: (file as UppyFile<Record<string, unknown>, Record<string, unknown>>).id,
        };
      } else {
        return {
          ...(file as unknown as Asset),
          local: false,
        };
      }
    });
  }, [files]);

  const handleAddFile = (fileId: string) => {
    setFiles([...files, {id: fileId} as unknown as UppyFile<Record<string, unknown>, Record<string, unknown>>]);
  };

  const handleRemoveFile = (fileId: string) => {
    setFiles(files.filter(file => file.id !== fileId));
  };

  const handleChangeFile = (fileId: string, data: Partial<Asset>) => {
    setFiles(files.map(file => file.meta.uuid === fileId ? {...file, ...data} as unknown as UppyFile<Record<string, unknown>, Record<string, unknown>> : file));
  };

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    assets.forEach(async (asset) => {
      const response = await APIupdateAsset(asset.id as string, {
        title: asset.title,
        groups: asset.groups,
        metadata: asset.metadata as AssetMetadata,
        shared: true,
      });
    });
    console.log(assets);
  };

  return (
    <>
      <div className="dashboard-header page-header wa-cluster">
        <div>
          <h2 className="page-title">Add new <em>SPRK images</em></h2>
          <p>Add new images to use in SPRKs</p>
        </div>
      </div>
      <div className="dashboard-admin dashboard-admin-assets-add wa-stack wa-gap-0 inner">
          <form onSubmit={handleSubmit}>
            <DashboardAdminAssetsUpload
              addFile={handleAddFile}
              removeFile={handleRemoveFile}
              setUploading={setUploading}
              setFiles={setFiles}
              assets={assets as Asset[]}
              assetGroups={assetGroups}
              handleChangeFile={handleChangeFile}
            />
            <div className="wa-cluster asset-form-actions inner">
              {files.length > 0 && (
                <wa-button
                  type="submit"
                  disabled={uploading}
                >
                  Save Images
                </wa-button>
              )}
            </div>
          </form>
      </div>
    </>
  );
}

export default DashboardAdminAssetsAdd;
